/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountCategoryEnum } from './accountCategoryEnum';
import { AccountStateEnum } from './accountStateEnum';


export interface AccountPatchRequestSpec { 
    /**
     * Name for an account.
     */
    account_name?: string;
    /**
     * Batch Id to which this account belongs.
     */
    batch_id?: string;
    category?: AccountCategoryEnum;
    /**
     * Patch the master account id if it\'s UNKNOWN.
     */
    master_account_id?: string;
    /**
     * Used for partitioning accounts.
     */
    org_unit?: string;
    state?: AccountStateEnum;
    /**
     * Team to which account belongs.
     */
    team?: string;
    /**
     * Any comment related to account.
     */
    note?: string;
}
export namespace AccountPatchRequestSpec {
}


